import { CommonSelectInput } from 'components/common/form/select';
import { HitterDataSource } from 'lib_ts/enums/hitters.enums';
import { clone } from 'lodash';
import useHittersStore from 'stores/use-hitters-store';

export const SelectHitterDataSource = () => {
  const filters = useHittersStore((s) => s.filters);
  const loading = useHittersStore((s) => s.loading);

  return (
    <CommonSelectInput
      id="hitters-data-source"
      name="source"
      placeholder="common.source"
      options={Object.values(HitterDataSource).map((o) => ({
        label: o,
        value: o,
      }))}
      value={filters.source}
      onChange={(v) =>
        useHittersStore.setState((prev) => {
          const nextFilters = clone(prev.filters);

          if (!v) {
            delete nextFilters.source;
          } else {
            nextFilters.source = v as HitterDataSource;
          }

          return {
            filters: nextFilters,
          };
        })
      }
      disabled={loading}
      optional
      skipSort
    />
  );
};
